import axios from 'axios'

const apiClient = axios.create({
  // baseURL: 'https://localhost:44357',
  // baseURL: 'https://localhost:5001',
  baseURL: 'https://idealivecrmapi.azurewebsites.net',
  responseType: 'json',
  withCredentials: true,
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json'
  }
})

export default {
  apiClient,
  async getDataMuliplex2 (url1, url2) {
    const requestOne = apiClient.get(url1, {
      responseType: 'json',
      withCredentials: true
    })
    const requestTwo = apiClient.get(url2, {
      responseType: 'json',
      withCredentials: true
    })
    return await Promise.all([requestOne, requestTwo])
  },
  async getData (url) {
    return await apiClient.get(url)
  },
  async postData (uri, dataform) {
    return await apiClient({
      method: 'post',
      url: uri,
      data: dataform
    })
  },
  async deleteData (uri, id) {
    return await apiClient({
      method: 'delete',
      url: uri + '/' + id
    })
  },
  async putData (uri, id, dataform) {
    // Si no hay ID, hacer PUT sin ID en la URL
    const url = id ? `${uri}/${id}` : uri;
    
    return await apiClient({
      method: 'put',
      url: url,
      data: dataform
    })
  }

}
